export default __webpack_public_path__ + "static/media/lunch.747ce147.svg";